import React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { StepContainer } from '../../components/StepContainer/StepContainer';
import { StepFooter } from '../../components/StepFooter/StepFooter';
import { useCharitableGivingContext } from '../../context/useCharitableGivingContext';
import { FormValues, STEP_ID, validation } from './CharityName.meta';
import { INPUTS_WIDTH } from '../../CharitableGiving.meta';
import { useNavigation } from '../../hooks/useNavigation';
import { Input } from '../../../../../CommonComponents/OPL/Input/Input';
import { WorkflowDTO } from '../../api/useCharitableGivingQuery';

export const CharityName = () => {
  const { workflow, setWorkflow, setStep } = useCharitableGivingContext();

  const { progress, previousStep, nextStep, isFirstStep } = useNavigation({ currentStep: STEP_ID });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({
    defaultValues: {
      charityName: workflow.data.charityName,
    },
    resolver: yupResolver(validation),
  });

  const onSubmit = handleSubmit(values => {
    const newWorkflow: WorkflowDTO = {
      ...workflow,
      data: {
        ...workflow.data,
        charityName: values.charityName,
      },
    };

    setWorkflow(newWorkflow);

    if (nextStep) {
      setStep(nextStep);
    }
  });

  return (
    <StepContainer
      title="What is the charity name?"
      onSubmit={onSubmit}
      footer={
        <StepFooter
          isFirstStep={isFirstStep}
          progress={progress}
          onPrevious={previousStep ? () => setStep(previousStep) : undefined}
        />
      }
    >
      <Input
        {...register('charityName')}
        label="Charity Name"
        formVariant={errors.charityName ? 'error' : undefined}
        helperText={errors.charityName?.message}
        style={{ width: INPUTS_WIDTH }}
      />
    </StepContainer>
  );
};
